var React = require('react');

function H2 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"H2"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("polygon",{"points":"42.02 1.17 43.37 29.89 24.52 30.64 18.29 51.06 44.49 49.94 46.07 81.1 69.11 79.93 65.06 0 42.02 1.17","fill":"#e5c83d","key":0}),React.createElement("g",{"style":{"mixBlendMode":"multiply"},"key":1},React.createElement("rect",{"x":"1.1","y":"1.25","width":"23.07","height":"80.03","transform":"translate(1.14 -0.33) rotate(1.58)","fill":"#73c9bd"}))])]);
}

H2.defaultProps = {"viewBox":"0 0 69.11 81.59"};

module.exports = H2;

H2.default = H2;
